import { ModelResidentFilterInput, SearchableResidentFilterInput } from "../../../../API";

const buildSearchFilter = (searchkey: string): SearchableResidentFilterInput => {
  //Trim to remove space, when searching
  const searchingResidents = searchkey.trim().toLocaleLowerCase();
  
  // Split the search key into parts for firstName and lastName
  const searchParts = searchingResidents.split(' ');

  if (searchParts.length === 2) {
    // If both firstName and lastName are provided, match them with regex
    return {
      and: [
        { firstName: { regexp: `.*${searchParts[0]}.*` } },
        { lastName: { regexp: `.*${searchParts[1]}.*` } },
      ],
    };
  } else {
    // If only firstName or only lastName is provided, match firstName or lastName with regex
    return {
      or: [
        { firstName: { regexp: `.*${searchParts[0]}.*` } },
        { lastName: { regexp: `.*${searchParts[0]}.*` } },
      ],
    };
  }
};



const buildFilter = (
  community: string | undefined,
  activeLevelOfCare: string | undefined,
  searchKey: string | undefined
): ModelResidentFilterInput => {
  const filter: ModelResidentFilterInput = {};

  if (community) {
    filter.and = [{ community: { eq: community } }];
  }

  if (activeLevelOfCare) {
    filter.and = filter.and || [];
    filter.and.push({ activeLevelOfCare: { eq: activeLevelOfCare } });
  }
  if (searchKey) {
    filter.and = [...(filter.and ?? []), buildSearchFilter(searchKey)];
  }

  return filter;
};


export default buildFilter;


